import {AnyDeviceModelType} from 'app/components/DeviceDetails/Models/Fabric';

export function isDisabledAudioMeter(device: AnyDeviceModelType): boolean {
  return (device.isOffline() || !device.caps.audioLevels?.enabled) ?? false;
}
